import { healthcareSitesRouteStore } from '../domain/store';
import { healthcareSiteUpsertModalRouteStore } from '../components/healthcare-site-upsert-modal/domain/store';

export default () => {
  healthcareSiteUpsertModalRouteStore.setInitialState();
  healthcareSitesRouteStore.setValue('showingHealthcareSiteUpsertModal', false);
};
